import {Stack} from "@mui/material";
import ContentBox from "./ContentBox";
import {ArrowRightAlt as ArrowRightAltIcon} from "@mui/icons-material";
import React from "react";
import {useTranslation} from "react-i18next";

export interface DeviceAssignedContentProps {
    newNumber: string;
    newOrg: string;
    oldNumber: string;
    oldOrg: string;
    err: string;
}

export default function DeviceAssignedContent(props: Readonly<DeviceAssignedContentProps>) {
    const {newNumber, newOrg, oldOrg, oldNumber, err} = props;
    const {t} = useTranslation();

    return (
        <ContentBox>
            <Stack direction="column" title={"Organization"}>
                <ContentBox>{err ? t("assignment_failed") : t("device_assigned")}</ContentBox>
                {err && <ContentBox>{err}</ContentBox>}
            </Stack>
            <Stack direction="row" title={"Organization"}>
                <ContentBox>{t("generic_customer")}</ContentBox>
                <ContentBox> : </ContentBox>
                <ContentBox>{oldNumber || "-"}</ContentBox>
                <ArrowRightAltIcon fontSize="small" />
                <ContentBox>{newNumber || "-"}</ContentBox>
            </Stack>
            <Stack direction="row">
                <ContentBox>{t("generic_organization")}</ContentBox>
                <ContentBox> : </ContentBox>
                <ContentBox>{oldOrg || "-"}</ContentBox>
                <ArrowRightAltIcon fontSize="small" />
                <ContentBox>{newOrg || "-"} </ContentBox>
            </Stack>
        </ContentBox>
    );
}
